import { checksForCard, type FillApplicationState, FillCard, type FillCheck } from '@/models/fillApplication'
import type { BusinessOwner } from '@/models/user'
import { DriversRoster } from './DriversRoster'
import { EldButton } from './EldButton'
import { FillSectionCard } from './FillSectionCard'
import { FillTabSection } from './FillTabSection'
import { TrailersRoster } from './TrailersRoster'
import { TrucksRoster } from './TrucksRoster'

interface EquipmentCardProps {
  orgId: string
  checks: FillCheck[]
  eld: FillApplicationState['eld']
  owner: BusinessOwner | null | undefined
  /** No card around each roster, for a surface that's already one, e.g. a dialog: rosters split by a rule. */
  plain?: boolean
  /** Leaves out Connect ELD, e.g. on the customer's review, which only edits the rosters. */
  hideEldButton?: boolean
  /** Leaves out trailers, which a contractor doesn't have. */
  withoutTrailers?: boolean
}

export function EquipmentCard({
  orgId,
  checks,
  eld,
  owner,
  plain,
  hideEldButton,
  withoutTrailers,
}: EquipmentCardProps) {
  return (
    <FillTabSection
      card={FillCard.EQUIPMENT}
      title="Equipment and drivers"
      checks={checksForCard(checks, FillCard.EQUIPMENT)}
      action={hideEldButton ? undefined : <EldButton orgId={orgId} eld={eld} />}
    >
      {/* Untitled: each roster's header row carries its title beside its search and buttons. */}
      <FillSectionCard plain={plain}>
        <DriversRoster orgId={orgId} owner={owner} />
      </FillSectionCard>
      <FillSectionCard plain={plain}>
        <TrucksRoster orgId={orgId} />
      </FillSectionCard>
      {!withoutTrailers && (
        <FillSectionCard plain={plain}>
          <TrailersRoster orgId={orgId} />
        </FillSectionCard>
      )}
    </FillTabSection>
  )
}
